import { useState } from 'react'
import { useForm } from 'react-hook-form'

import MarketTradeInput from '../MarketTradeInput'
import MarketTradePercentages from '../MarketTradePercentages'
import MarketTradeInfo from '../MarketTradeInfo'
import MarketTradeButton from '../MarketTradeButton'

const MarketTradeBuy = () => {
  const { handleSubmit, register } = useForm({
    defaultValues: {
      price: '',
      amount: '',
    },
  })

  const [percentage, setPercentage] = useState()

  const handleFormSubmit = () => {}

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="flex-1 pr-[15px]">
      <div className="w-full flex flex-col gap-y-[14px] mb-[14px]">
        <MarketTradeInput placeholder="Price" currency="BTC" {...register('price')} />

        <MarketTradeInput placeholder="Amount" currency="ETH" {...register('amount')} />
      </div>

      <MarketTradePercentages activePercentage={percentage} onPercentageChange={setPercentage} />

      <MarketTradeInfo />

      <MarketTradeButton background="bg-[#26de81]" shadow="shadow-market-trade-buy">
        BUY
      </MarketTradeButton>
    </form>
  )
}

export default MarketTradeBuy
